<template>
  <div>
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      :searchData="channelUserSearchData"
      :isHaveExport="false"
      :HeadShow="false"
      :sizes="[10, 20, 50, 100]"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
    >
      <template #table>
        <el-table v-if="!isMobileViewport" :data="list" border stripe v-loading="loading">
          <el-table-column prop="id" label="用户ID" align="center" width="90" />
          <el-table-column prop="username" label="用户名" align="center" min-width="140" />
          <el-table-column prop="nickname" label="用户昵称" align="center" min-width="140" />
          <el-table-column label="APP" align="center" min-width="140">
            <template slot-scope="{ row }">
              {{ row.app && row.app.app_name ? row.app.app_name : "--" }}
            </template>
          </el-table-column>
          <el-table-column label="渠道" align="center" min-width="140">
            <template slot-scope="{ row }">
              {{ row.channel && row.channel.nickname ? row.channel.nickname : "--" }}
            </template>
          </el-table-column>
          <el-table-column prop="channel_id" label="渠道ID" align="center" width="110" />
          <el-table-column prop="ad_list" label="今日广告数" align="center" width="110" />
          <el-table-column label="今日广告收益" align="center" min-width="160">
            <template slot-scope="{ row }">
              {{ row.ecpm_total || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="140">
            <template slot-scope="{ row }">
              <template v-if="row.banned_time && row.banned_time * 1000 > Date.now()">
                <el-tag type="danger">
                  封禁至 {{ $fnc.getTimeFormat(row.banned_time, "ymdhms") }}
                </el-tag>
              </template>
              <el-tag v-else type="success">正常</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="注册时间" align="center" min-width="160">
            <template slot-scope="{ row }">
              {{ $fnc.getTimeFormat(row.created_time, "ymdhms") }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            :width="isMobileViewport ? 76 : 240"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <responsive-actions
                :items="getUserAdRowActions(row)"
                @select="handleUserAdRowAction($event, row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <mobile-record-list
          v-else
          :rows="list"
          :loading="loading"
          :title="getMobileUserAdTitle"
          :subtitle="getMobileUserAdSubtitle"
          :fields="mobileUserAdFields"
          :actions="getUserAdRowActions"
          @action="handleUserAdRowAction"
        />
      </template>
    </tableComponents>
    <user-trigger-rules ref="userTriggerRef"></user-trigger-rules>
    <user-ad-list ref="userAdRef"></user-ad-list>
    <user-ad-log-list ref="userAdLogRef"></user-ad-log-list>
  </div>
</template>

<script>
import UserTriggerRules from "@/comment/userTriggerRules.vue";
import UserAdList from "@/comment/userAdList.vue";
import UserAdLogList from "@/comment/userAdLogList.vue";
import responsiveMixin from "@/mixins/responsive";

export default {
  mixins: [responsiveMixin],
  components: { UserTriggerRules, UserAdList, UserAdLogList },
  props: {
    channelId: {
      type: [String, Number],
      default: "",
    },
    appId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      queryForm: {},
      total: 0,
      paginationForm: {
        page: 1,
        page_size: 10,
      },
    };
  },
  computed: {
    mobileUserAdFields() {
      return [
        { label: "APP", value: (row) => row.app && row.app.app_name },
        { label: "渠道", value: (row) => row.channel && row.channel.nickname },
        { label: "今日广告", value: (row) => row.ad_list || 0 },
        { label: "今日收益", value: (row) => row.ecpm_total },
        { label: "用户ID", key: "id", summary: false },
        { label: "账号", key: "username", summary: false },
        { label: "渠道ID", key: "channel_id", summary: false },
        {
          label: "状态",
          value: (row) =>
            row.banned_time && row.banned_time * 1000 > Date.now()
              ? `封禁至 ${this.$fnc.getTimeFormat(row.banned_time, "ymdhms")}`
              : "正常",
          tag: true,
          tagType: (row) =>
            row.banned_time && row.banned_time * 1000 > Date.now() ? "danger" : "success",
          summary: false,
        },
        {
          label: "注册时间",
          value: (row) => this.$fnc.getTimeFormat(row.created_time, "ymdhms"),
          summary: false,
        },
      ];
    },
    channelUserSearchData() {
      return () => [
        {
          title: "",
          type: "1",
          data: [
            {
              type: "date",
              arr: [],
              key: ["start_time", "end_time"],
              placeholder: "注册时间",
            },
          ],
        },
        {
          title: "",
          type: "2",
          data: [
            { type: "text", key: "nickname", placeholder: "搜索用户昵称" },
            { type: "text", key: "username", placeholder: "搜索用户名" },
            { type: "text", key: "id", placeholder: "搜索用户ID" },
            {
              type: "select",
              key: "app_id",
              option: this.$store.getters.getAppListGetter,
              placeholder: "所属APP",
              onChange: () => {},
            },
          ],
        },
      ];
    },
  },
  methods: {
    getMobileUserAdTitle(row) {
      return row.nickname || row.username || `用户 #${row.id}`;
    },
    getMobileUserAdSubtitle(row) {
      return `用户ID ${row.id}`;
    },
    getUserAdRowActions(row) {
      return [
        { key: "trigger", label: "封控记录", type: "danger" },
        { key: "ad", label: "广告记录", type: "primary" },
        { key: "adlog", label: "其他广告", type: "info" },
        {
          key: "ban",
          label:
            row.banned_time && row.banned_time * 1000 > Date.now()
              ? "解除封禁"
              : "封禁",
          type: "warning",
        },
      ];
    },
    handleUserAdRowAction(key, row) {
      const dialogRefs = {
        trigger: "userTriggerRef",
        ad: "userAdRef",
        adlog: "userAdLogRef",
      };
      if (dialogRefs[key]) this.openDialog(row.id, dialogRefs[key]);
      if (key === "ban") this.toggleBan(row);
    },
    openDialog(userId, key) {
      this.$refs[key].openDialog(userId);
    },
    async getList() {
      const params = {
        ...this.paginationForm,
        ...this.queryForm,
      };

      if (this.channelId) {
        params.channel_id = this.channelId;
      } else if (this.appId) {
        params.app_id = this.appId;
      }

      this.loading = true;
      try {
        const data = await this.$api.getChannel.getChannelUserList(params);
        this.total = data.data && data.data.count ? data.data.count : 0;
        this.list = data.data && data.data.list ? data.data.list : [];
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.paginationForm.page = 1;
      this.getList();
    },
    getSearch(form) {
      this.queryForm = form || {};
      this.paginationForm.page = 1;
      this.getList();
    },
    toggleBan(row) {
      const active = row.banned_time && row.banned_time * 1000 > Date.now();
      if (active) {
        this.$confirm("确认解除该渠道用户封禁吗？", "提示", {
          type: "warning",
        }).then(async () => {
          const data = await this.$api.getUser.postBannedUser({
            user_id: row.id,
            time: 0,
          });
          if (data.code === 200) {
            this.$message.success("已解除封禁");
            this.getList();
          }
        });
        return;
      }

      this.$prompt("请输入封禁时长（秒）", "封禁渠道用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+$/,
        inputErrorMessage: "请输入正整数秒数",
      }).then(async ({ value }) => {
        const data = await this.$api.getUser.postBannedUser({
          user_id: row.id,
          time: value,
        });
        if (data.code === 200) {
          this.$message.success("封禁成功");
          this.getList();
        }
      });
    },
  },
  watch: {
    channelId: {
      immediate: true,
      handler() {
        this.paginationForm.page = 1;
        this.getList();
      },
    },
    appId() {
      this.paginationForm.page = 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table .el-table__cell {
  padding: 6px 0;
}
</style>
